module.exports = __webpack_public_path__ + "img/basket-icon.b901af64.svg";